import React, { Component } from "react";
import { connect } from "react-redux";
import { Header } from "semantic-ui-react";
import SRHCopyright from "./../../../../components/SRHCopyright";
import ReportHeader from "./../../../../components/ReportHeader";
import Printable from "./../../../../components/Printable";
import KeyDriverCircles from "./../../../../components/KeyDriverCircles";
import { SrhJumbotron, BestWorstRow, BestWorstItem } from "./style.js";
import _ from "lodash";
import clsx from "clsx";
import Grid from "@material-ui/core/Grid";
import FiltersFooter from "../FiltersFooter";

class Insights extends Component {
  mapInsights(insightArray, landscape, breathingRoom, iconName, iconColor) {
    return insightArray && insightArray.map((insight, index) => {
      return (
        <BestWorstRow key={`topCulture-${index}`} className={breathingRoom}>
          <div className={`perc ${breathingRoom}`}>
            {insight.questionPercentile}
            {insight.questionPercentileOrdinal}
          </div>
          <BestWorstItem className={clsx(breathingRoom, { insightLandscape: landscape })}>
            {insight.questionText}
          </BestWorstItem>
        </BestWorstRow>
      );
    });
  }

  render() {
    const { bestWorst, unit, ready, page, summaryReport, showInlineValuesOnDonuts, landscape } = this.props;
    const { totalRespondents, datasetName, workSettingsSurveyed, survey, configuration } = summaryReport;

    let surveyType = survey && survey.replace(/_Pulse/g, "");
    if (survey === 'SELECT_2020') surveyType = 'SCORE';
    if (survey === 'VALLEY_2020') surveyType = 'SCOR';
    if (survey === 'SHA_2020') surveyType = 'SCORE';
    if (/PENN.*_Pulse_2020/.test(survey)) surveyType = 'SCOR';
    if (configuration && configuration.survey_type) surveyType = configuration.survey_type;

    const breathingRoom = surveyType === "SCORE" || landscape ? "" : "breathing-room";

    const mappedTopCulture = this.mapInsights(bestWorst.cultureBest, landscape, breathingRoom, "arrow up", "green");
    const mappedLowCulture = this.mapInsights(bestWorst.cultureWorst, landscape, breathingRoom, "arrow down", "red");
    const mappedTopEngagement =
      surveyType === "SCORE" &&
      this.mapInsights(bestWorst.engagementBest, landscape, breathingRoom, "arrow up", "green");
    const mappedLowEngagement =
      surveyType === "SCORE" &&
      this.mapInsights(bestWorst.engagementWorst, landscape, breathingRoom, "arrow down", "red");

    let surveyTitle = surveyType;
    if (/PENN.*_Pulse_2020/.test(survey)) surveyTitle = 'SCORE';
    if (configuration && configuration.survey_title) surveyTitle = configuration.survey_title;

    const smallLogo =
      summaryReport && 
      summaryReport.configuration &&
      summaryReport.configuration.key_drivers &&
      summaryReport.configuration.key_drivers.rows &&
      summaryReport.configuration.key_drivers.rows.portrait &&
      summaryReport.configuration.key_drivers.rows.portrait.length > 2;
    return (
      <Printable page={page} landscape={landscape}>
        {ready && (
          <div>
            <ReportHeader
              title={`Notable Insights by Percentile and Key ${surveyTitle} Items`}
              totalRespondents={totalRespondents}
              workSettingsSurveyed={workSettingsSurveyed}
              datasetName={datasetName}
              unit={unit}
              smallerHeader
              summaryReport={summaryReport}
            />
            <SrhJumbotron className={breathingRoom}>
              <Grid container spacing={2} className={clsx("bestWorsts", { rowLandscape: landscape })}>
                <Grid item xs={6} className="mainGridPadding">
                  <div className="header-row">
                    <div>%ile</div>
                    <Header as="h3">Cultural Strengths</Header>
                  </div>
                  {mappedTopCulture}
                </Grid>
                {surveyType === "SCORE" && (
                  <Grid item xs={6} className="mainGridPadding rightColumn">
                    <div className="header-row">
                      <div>%ile</div>
                      <Header as="h3">Engagement Strengths</Header>
                    </div>
                    {mappedTopEngagement}
                  </Grid>
                )}
                <Grid item xs={6} className="mainGridPadding">
                  <div className="header-row">
                    <div>%ile</div>
                    <Header as="h3">Cultural Opportunities</Header>
                  </div>
                  {mappedLowCulture}
                </Grid>
                {surveyType === "SCORE" && (
                  <Grid item xs={6} className="mainGridPadding rightColumn">
                    <div className="header-row">
                      <div>%ile</div>
                      <Header as="h3">Engagement Opportunities</Header>
                    </div>
                    {mappedLowEngagement}
                  </Grid>
                )}
              </Grid>
            </SrhJumbotron>
            <KeyDriverCircles showInlineValuesOnDonuts={showInlineValuesOnDonuts} landscape={landscape} />
            <FiltersFooter />
            <SRHCopyright textClass="large-font" smallLogo={smallLogo}/>
          </div>
        )}
      </Printable>
    );
  }
}
export default connect(store => {
  return {
    summaryReport: store.summaryReport.summaryReport,
    bestWorst: store.bestWorst.bestWorst,
  };
})(Insights);



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Insights/index.jsx